<template>
  <section id="dealership-locations" class="dealership-locations" data-0="opacity:0;" data-center-top="opacity:1;">
    <div class="content">
      <h2 class="align-center">Locations</h2>
      <div class="locations">
        <div class="dealerships-contact">
          <div class="dealerships">
            <div class="list">
              <div class="state">
                <h3>Massachusetts</h3>
                <span class="location" data-location="shrewsbury"><a href="http://www.tristatetruckcenter.com/" target="_blank">Shrewsbury</a></span>
                <span class="location" data-location="westfield"><router-link to="/locations/westfield/" class="internal-link">Westfield</router-link></span>
                <p>New Massachusetts Dealership Coming Soon!</p>
              </div>
            </div>
            <div class="list">
              <div class="state">
                <h3>New Hampshire</h3>
                <span class="location" data-location="lancaster"><a href="https://www.mctrucks.com/lancaster-newhampshire-truck-dealer" target="_blank">Lancaster</a></span>
                <span class="location" data-location="manchester"><a href="https://www.mctrucks.com/manchester-new-hampshire-truck-dealer" target="_blank">Manchester</a></span>
                <span class="location" data-location="seabrook"><router-link to="/locations/seabrook/" class="internal-link">Seabrook</router-link>*</span>
              </div>
              <div class="state">
                <h3>Vermont</h3>
                <span class="location" data-location="westminster"><router-link to="/locations/westminster/" class="internal-link">Westminster</router-link></span>
              </div>
            </div>
          </div>
          <div class="disclaimer">*(Western Star Only)</div>
          <div class="contact">
            <img src="../assets/img/We-Know-Trucks-TM.png"/>
            <span class="spacer"></span>
            <p>Contact Us Today!</p>
            <p>
              <a href="tel:888-874-9120">888.874.9120</a>
              <a href="mailto:info@advantagetruckne.com">info@advantagetruckne.com</a>
            </p>

          </div>
        </div>
        <!-- render map -->
        <div class="map">
          <location-map/>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

  import locationMap from '../assets/img/map.svg';

  export default {
    name:'HomeLocations',
    components:{
      locationMap
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/HomeLocations.vue